<template>
  <div class="top-swiper">
    <swiper class="swiper" :style="{maxHeight: `${height}px`}" :options="swiperOption">
      <swiper-slide v-for="(item, index) in banners" :key="index">
        <img :src="$utils.getFileHttpUrl(item.img)" @click="gotoHref(item.href)" />
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: { Swiper, SwiperSlide },
  props: {
    location: {
      type: String,
    },
    height: {
      type: Number,
      default: 320
    }
  },
  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      banners: []
    }
  },
  created() {
    this.getBanners()
  },
  methods: {
    gotoHref(href) {
      if (this.$utils.isUrl(href)) {
        window.open(href)
      }
    },
    getBanners() {
      console.log(this.location, 111)
      this.$http.getAction('/portal/api/v1/index/banners?location=' + this.location).then((res) => {
        if (res.success) {
          this.banners = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.top-swiper {
  .swiper {
    width: 100%;
    .swiper-slide {
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
        cursor: pointer;
      }
    }
  }
}
</style>